import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";

/**
 * Component to render Nominations Description of E50 on homepage
 */
const E50NominationsDescription = (): React.ReactElement => {
  return (
    <div
      className="flex w-full flex-row items-center justify-center text-center md:px-0 lg:mx-auto lg:w-10/12"
      data-testid="e50-nominations-description-component"
    >
      <IconFactory
        type={IconTypeEnum.apply}
        x={67}
        y={62}
        size={67}
        className="mr-2 md:mr-4"
      />

      <div className="flex-col items-center justify-center text-center font-public-sans text-gray-850">
        <h2 className="text-center align-middle font-poppins text-4xl font-medium md:text-6xl lg:text-8xl lg:leading-tight">
          {"Nominations for "}
          <br className="inline md:hidden" />
          {"2025 Enterprise "}
          <br className="inline lg:hidden" />
          {"50 are now closed"}
        </h2>
      </div>
    </div>
  );
};

export default E50NominationsDescription;
